module.exports = __webpack_public_path__ + "static/media/loading.f8f8d7da.gif";